import withSizes from 'react-sizes'

const mapSizesToProps = ({ width }) => ({
    isDesktop: width > 1900,
    isNotebook: width <= 1900,
    isMobile: width <= 1150
});

export default withSizes(mapSizesToProps)